export enum ProjectMemberViewMode {
  GRID = 'grid',
  LIST = 'list',
}

export interface UserConfigState {
  userConfig: {
    projectPage: {
      projectMemberViewMode?: ProjectMemberViewMode;
      showRoleLabel: boolean;
    };
  };
}

export interface UserConfigActions {
  setProjectMemberViewMode: (viewMode: ProjectMemberViewMode) => void;
  setShowRoleLabel: (showRoleLabel: boolean) => void;
  resetUserConfig: () => void;
}

export interface UserConfigSlice extends UserConfigState, UserConfigActions {}
